import { getClientDetails } from './client.api';

const actionPrefix = (actionType) => `Client/${actionType}`;

export const SET_CLIENT_DETAILS = actionPrefix`SET_CLIENT_DETAILS`;
export const setClientDetails = (details) => ({
  type: SET_CLIENT_DETAILS,
  payload: details,
});

export const loadClientDetails = () => (dispatch) =>
  getClientDetails().then((details) => {
    dispatch(setClientDetails(details));
  });
